import script from "./ForgotPassSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPassSuccess.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPassSuccess.vue?vue&type=style&index=0&id=85027f18&lang=scss"

const __exports__ = script;

export default __exports__